module.exports = __webpack_public_path__ + "img/carrental-banner.4db8296f.jpg";